import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { UnavailableDate } from './unavailable-date.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class UnavailableDateService extends AbstractEntityService {

    protected resourceUrl = 'api/unavailable-dates';
    private resourceSearchUrl = 'api/_search/unavailable-dates';
    protected resourceCountUrl = 'api/_search/count/unavailable-dates';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(unavailableDate: UnavailableDate): Observable<UnavailableDate> {
        let copy: UnavailableDate = Object.assign({}, unavailableDate);
        copy.begining = this.dateUtils
            .convertLocalDateToServer(unavailableDate.begining);
        copy.ending = this.dateUtils
            .convertLocalDateToServer(unavailableDate.ending);
        return this.http.post<UnavailableDate>(this.resourceUrl, copy).map((res: UnavailableDate) => {
            return res;
        });
    }

    update(unavailableDate: UnavailableDate): Observable<UnavailableDate> {
        let copy: UnavailableDate = Object.assign({}, unavailableDate);
        copy.begining = this.dateUtils
            .convertLocalDateToServer(unavailableDate.begining);
        copy.ending = this.dateUtils
            .convertLocalDateToServer(unavailableDate.ending);
        return this.http.put<UnavailableDate>(this.resourceUrl, copy).map((res: UnavailableDate) => {
            return res;
        });
    }

    find(id: number): Observable<UnavailableDate> {
        return this.http.get<UnavailableDate>(`${this.resourceUrl}/${id}`).map((res: UnavailableDate) => {
            let jsonResponse = res;
            jsonResponse.begining = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.begining);
            jsonResponse.ending = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.ending);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<UnavailableDate[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<UnavailableDate[]>>(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    search(req?: any): Observable<HttpResponse<UnavailableDate[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<UnavailableDate[]>>(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    private convertResponse(res: HttpResponse<UnavailableDate[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].begining = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].begining);
            jsonResponse[i].ending = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].ending);
        }
        return res.clone({body: jsonResponse});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date.service.ts